var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizztimeAvailableWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.875,
    cy: 32.875,
    r: 7,
    stroke: "#27B65B",
    strokeWidth: 2.04878
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.4658,
    y: 27.543,
    width: 0.820312,
    height: 1.64062,
    rx: 0.410156,
    fill: "#27B65B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4658,
    y: 36.5664,
    width: 0.820312,
    height: 1.64062,
    rx: 0.410156,
    fill: "#27B65B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5664,
    y: 33.2852,
    width: 0.820312,
    height: 1.64062,
    rx: 0.410156,
    transform: "rotate(-90 32.5664 33.2852)",
    fill: "#27B65B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.543,
    y: 33.2852,
    width: 0.820312,
    height: 1.64062,
    rx: 0.410156,
    transform: "rotate(-90 23.543 33.2852)",
    fill: "#27B65B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9922,
    y: 29.8125,
    width: 0.820312,
    height: 0.820313,
    rx: 0.410156,
    transform: "rotate(-90 24.9922 29.8125)",
    fill: "#27B65B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9385,
    y: 29.8125,
    width: 0.820312,
    height: 0.820313,
    rx: 0.410156,
    transform: "rotate(-90 31.9385 29.8125)",
    fill: "#27B65B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9385,
    y: 36.7578,
    width: 0.820312,
    height: 0.820313,
    rx: 0.410156,
    transform: "rotate(-90 31.9385 36.7578)",
    fill: "#27B65B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9922,
    y: 36.7578,
    width: 0.820312,
    height: 0.820313,
    rx: 0.410156,
    transform: "rotate(-90 24.9922 36.7578)",
    fill: "#27B65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4658 32.7383V30.3184C28.5314 30.1215 28.7119 30.0449 28.7939 30.0312C29.1658 30.0312 29.2998 30.25 29.2998 30.3594V32.6289V32.7383L29.9697 33.3945L31.6514 35.1035C31.8592 35.4316 31.6195 35.6504 31.4736 35.7188C31.3096 35.7734 31.141 35.696 31.0771 35.6504L28.5752 33.1484C28.4986 33.0828 28.4704 32.9753 28.4658 32.9297V32.7383Z",
    fill: "#27B65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.166 7.50684C24.5593 7.52754 25.1499 7.64374 25.6504 7.93555C26.1587 8.23198 26.5976 8.72665 26.5977 9.48828V10.5273C26.5977 10.5331 26.5971 10.5391 26.5967 10.5449C26.5741 10.8617 26.4347 11.3205 26.0918 11.7041C25.7412 12.0962 25.1909 12.3945 24.3838 12.3945H12.3936V34.4307C12.3936 34.5687 12.2816 34.6807 12.1436 34.6807H7.75586C7.61784 34.6806 7.50586 34.5687 7.50586 34.4307V12.625H2.6748C2.65919 12.625 2.64326 12.624 2.62793 12.6211C2.18512 12.5367 1.53512 12.2813 0.991211 11.7861C0.440393 11.2846 2.28495e-05 10.5367 0 9.48828V7.75586C0.000157153 7.61795 0.112067 7.50591 0.25 7.50586H24.166V7.50684ZM20.4619 29.6768C20.0837 30.6709 19.875 31.7491 19.875 32.876C19.875 33.4536 19.9312 34.0181 20.0352 34.5654H14.7998C14.6619 34.5654 14.55 34.4533 14.5498 34.3154V29.9268C14.55 29.7889 14.6619 29.6768 14.7998 29.6768H20.4619ZM26.2314 0C26.7656 0 27.5276 0.162825 28.3584 0.462891C29.1938 0.76465 30.1181 1.21216 30.9805 1.7959C32.6963 2.95747 34.2186 4.69753 34.2188 6.94727V12.0283C34.2188 12.0381 34.2179 12.0479 34.2168 12.0576C34.1369 12.7368 33.8818 13.815 33.374 14.8682C32.9224 15.8048 32.2593 16.7416 31.3223 17.3516C32.4004 18.1241 34.2187 20.0271 34.2188 23.1143V25.6328C32.8967 24.6559 31.298 24.0342 29.5615 23.9033V23.4756C29.5357 23.2232 29.3966 22.8652 29.1396 22.458C28.8834 22.052 28.5232 21.617 28.0869 21.2178C27.2097 20.4151 26.0541 19.7842 24.8457 19.7842H14.7998C14.6618 19.7841 14.5498 19.6722 14.5498 19.5342V15.1465C14.5498 15.0085 14.6618 14.8966 14.7998 14.8965H25.6543C26.2376 14.8965 27.192 14.5066 28.0098 13.7959C28.8206 13.0912 29.4463 12.1151 29.4463 10.9893V8.82129C29.2577 7.72788 28.1898 5.44792 25.4014 5.00391H3.02148C3.00446 5.0039 2.98737 5.0015 2.9707 4.99805C2.48149 4.89611 1.75248 4.63536 1.13965 4.17676C0.524152 3.71611 2.10275e-05 3.03435 0 2.09766V0.25C4.08803e-05 0.111994 0.111995 4.86129e-05 0.25 0H26.2314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizztimeAvailableWhite);
export default __webpack_public_path__ + "static/media/BizztimeAvailableWhite.9244263f66959a4d052acbbe8c5e2c07.svg";
export { ForwardRef as ReactComponent };